import { getAllDrafts, getSubmissions } from '@/lib/db'

declare global {
  interface Window {
    logAudioStorageSummary?: () => Promise<void>
  }
}

export function attachAudioDebugTools(): void {
  if (typeof window === 'undefined') return
  window.logAudioStorageSummary = async () => {
    try {
      const drafts = await getAllDrafts()
      const submissions = await getSubmissions()
      console.log('[AUDIO DEBUG] Drafts', drafts.map((d) => ({
        id: d.id,
        blobType: d.blob?.type,
        blobSize: d.blob?.size,
      })))
      console.log('[AUDIO DEBUG] Submissions', submissions
        .filter((s) => s.type === 'audio')
        .map((s) => ({
          id: s.id,
          localBlobType: (s as any).localBlob?.type,
          localBlobSize: (s as any).localBlob?.size,
          syncedAt: s.syncedAt,
        })))
    } catch (error) {
      console.error('[AUDIO DEBUG] Failed to summarize storage', error)
    }
  }
}
